import { RouterProvider } from 'react-router-dom';
import './App.css';
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { AuthProvider } from 'contexts/AuthContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import queryClient from 'api/queryClient';
import { App as AntApp, message } from 'antd';
import { setAxiosInterceptors } from 'service/axiosInterceptor';

function AxiosInterceptorInit() {
  const { message: msg } = AntApp.useApp();
  setAxiosInterceptors(msg);
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
        <ThemeCustomization>
          <AntApp>
            <AuthProvider>
              <AxiosInterceptorInit />
              <ScrollTop>
                <RouterProvider router={router} />
              </ScrollTop>
            </AuthProvider>
          </AntApp>
        </ThemeCustomization>
      {/* <ReactQueryDevtools initialIsOpen={false} position="bottom" /> */}
    </QueryClientProvider>
  );
}
